var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-icon-group"},[_vm._t("default"),_vm._v(" "),(_vm.isVisible)?_c('a',{staticClass:"input-icon",attrs:{"href":"#","title":_vm.title},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('icon',{attrs:{"fa":_vm.fa}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }